import React, { useState, useMemo } from "react";
import PropTypes from "prop-types";

import { Tooltip } from "reactstrap";

import uuidv4 from "uuid/v4";

const BigComment = ({ comment, maxLength }) => {
  const [openedTooltip, setOpenedTooltip] = useState(false);
  const smallComment =
    comment && comment.length < maxLength + 3
      ? comment
      : `${comment ? comment.substring(0, maxLength) : ""}...`;

  const uuid = useMemo(() => `t${uuidv4().replace(/-/g, "")}`, []);
  return (
    <>
      <span
        id={uuid}
        onMouseEnter={() => setOpenedTooltip(true)}
        onMouseLeave={() => setOpenedTooltip(false)}
      >
        {smallComment}
      </span>
      <Tooltip placement="bottom" isOpen={openedTooltip} target={uuid}>
        {comment}
      </Tooltip>
    </>
  );
};

BigComment.propTypes = {
  comment: PropTypes.string,
  maxLength: PropTypes.number
};

BigComment.defaultProps = {
  comment: "",
  maxLength: 100
};

export default BigComment;
